class Monitoring.Views.SocialContents.Filters.SelectedListView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/keywords/selected_list"]

  events:
    'click .remove-item': 'onRemove'
    'click .logic': 'onChangeLogic'
    'click .clear-items': 'onClearItems'

  initialize: (@options = {}) ->
    super(@options)
    @selectedItems = @options.selectedItems || []
    @selectedLogic = @options.selectedLogic || "OR"

  render: ->
    @$el.html(@template({
      selectedItems: @selectedItems
      selectedLogic: @selectedLogic
    }))
    @

  onRemove: (evt) ->
    itemCode = $(evt.currentTarget).data('code').toString()
    @selectedItems = _.filter(@selectedItems, (item) -> item.code != itemCode)
    @trigger('removeItem', itemCode)
    @render()

  onChangeLogic: ->
    if @selectedLogic == "AND"
      @selectedLogic = "OR"
    else
      @selectedLogic = "AND"
    @$el.find('.logic-any').toggleClass('on').toggleClass('off')
    @$el.find('.logic-all').toggleClass('on').toggleClass('off')
    @trigger('changeLogic', @selectedLogic)

  onClearItems: ->
    @selectedItems = []
    @trigger('clearSelectedItems')
    @render()